/**
 * Extract a user-facing message from a failed API call (e.g. axios error).
 * Supports backend bodies like:
 * { success: false, message: "Language code already exists", error: { statusCode, status }, stack?: "..." }
 *
 * @param {unknown} err
 * @param {string} [fallback]
 * @returns {string}
 */
export function getApiErrorMessage(err, fallback = 'Something went wrong. Please try again.') {
  if (err == null) return fallback;
  const data = err.response?.data;
  if (data && typeof data.message === 'string' && data.message.trim()) {
    return data.message.trim();
  }
  if (Array.isArray(data?.errors)) {
    const parts = data.errors.map((e) => e?.msg ?? e?.message).filter(Boolean);
    if (parts.length) return parts.join('; ');
  }
  if (typeof err.message === 'string' && err.message.trim()) {
    return err.message.trim();
  }
  return fallback;
}
